import { datadogLogs } from '@datadog/browser-logs'


const initDatadogLogs = () => {
  datadogLogs.init({
    clientToken: process.env.REACT_APP_TOKEN_DATADOG ? process.env.REACT_APP_TOKEN_DATADOG : '',
    site: 'datadoghq.com',
    service:'catalogue',
    env:'local',
    forwardErrorsToLogs: true,
    sampleRate: 100,
  })
}
export default initDatadogLogs